<section class="token-intro">
    <div class="token-intro-content">
        <div class="container">
            <h1 class="intro-title">LIS token utility</h1>
            <div class="description">LIS token will serve as a fuel to all processes in the Realis economy, it will
                connect and redistribute assets between different parts of the ecosystem for organic interaction.
            </div>
        </div>
    </div>
</section>

<style>
    .token-intro {
        position: relative;
        padding: 125px 0 0;
        margin-bottom: 40px;
    }

    .token-intro-content {
        position: relative;
        z-index: 2;
    }

    .intro-title {
        font-family: "Echoes Sans", sans-serif;
        font-size: 72px;
        color: white;
        margin: 0 0 35px;
        line-height: 72.65px;
        text-align: center;
    }

    .description {
        font-size: 24px;
        line-height: 32.78px;
        color: white;
        max-width: 800px;
        margin: 0 auto;
        text-align: center;
    }

    @media (max-width: 1200px) {
        .intro-title {
            font-size: 56px;
        }
    }

    @media (max-width: 992px) {
        .intro-title {
            font-size: 44px;
        }
    }

    @media (max-width: 767px) {
        .token-intro {
            margin-bottom: 30px;
            padding: 100px 0 0;
            height: auto;
        }

        .intro-title {
            font-size: 40px;
            line-height: 40.36px;
            margin-bottom: 30px;
        }

        .description {
            font-size: 16px;
            line-height: 21.86px;
        }
    }
</style>
